import { FuelButton, FuelDivider, FuelIcon, FuelTooltip, FuelTypography } from '@frete.com/fuel-react';
import { FuelFlex } from '@frete.com/fuel-station-react';
import { DS_TOKENS } from 'constants/styled.contants';
import { ITruckerProfileProps } from 'interfaces/profile.interface';
import { ButtonCustomProps } from 'open-search/types';
import React from 'react';
import * as Styled from './styled';

type BodyProps = {
  searchedTrucker: ITruckerProfileProps;
  hasAccount: boolean;
  copyButtonProps: ButtonCustomProps;
};

const Body: React.FC<BodyProps> = ({ searchedTrucker, hasAccount, copyButtonProps }) => {
  const { journey, evaluation } = searchedTrucker;
  return (
    <FuelFlex defaultProps={{ justifyContent: 'space-around', customMargin: `0 0 ${DS_TOKENS.spacing.km6} 0` }}>
      <FuelFlex
        defaultProps={{
          flexDirection: 'column',
          alignItems: 'center',
          customPadding: `${DS_TOKENS.spacing.km3} 0 0 ${DS_TOKENS.spacing.km3}`,
        }}
      >
        <FuelTypography
          size="body-lg"
          color="neutral-strong"
          weight="bold"
          data-testid="body-desktop-card-travels-ammount"
        >
          {journey?.total ? journey?.total : 0}
        </FuelTypography>
        <FuelTypography size="body-sm" color="neutral-default" weight="medium">
          viagens feitas
        </FuelTypography>
      </FuelFlex>
      <FuelDivider orientation="vertical" />

      <FuelFlex
        defaultProps={{ flexDirection: 'column', alignItems: 'center', customPadding: `${DS_TOKENS.spacing.km3} 0 0` }}
      >
        <FuelTypography size="body-lg" color="neutral-strong" weight="bold">
          {evaluation?.grade}
          <Styled.StarWrapper>
            <FuelIcon name="star" iconStyle="filled" size="tiny" data-testid="rating-icon" />
          </Styled.StarWrapper>
        </FuelTypography>
        <FuelTypography size="body-sm" color="neutral-default" weight="medium">
          {evaluation?.total} avaliações
        </FuelTypography>
      </FuelFlex>
      <FuelDivider orientation="vertical" />
      <Styled.Account hasAccount={hasAccount}>
        {hasAccount ? (
          <>
            <FuelFlex
              defaultProps={{ flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-end', gap: 'km2' }}
            >
              <FuelIcon name="payment" iconStyle="outlined" size="medium" data-testid="account-availaible-icon" />
              <FuelTypography size="body-sm" color="neutral-default" weight="medium">
                com conta digital
              </FuelTypography>
            </FuelFlex>
            <FuelButton
              variant="secondary"
              size="small"
              trailingIcon="duplicate"
              trailingIconStyle="filled"
              onClick={() => copyButtonProps.events.onClick()}
              data-testid="copy-pix-button"
            >
              {copyButtonProps.states.textContent}
            </FuelButton>
          </>
        ) : (
          <FuelTooltip
            size="sm"
            label="Este motorista não tem conta digital Fretebras."
            placement="top-end"
            data-testid="account-tooltip"
          >
            <FuelFlex
              defaultProps={{ flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-end', gap: 'km2' }}
            >
              <FuelIcon name="alert" iconStyle="outlined" size="medium" data-testid="account-not-availaible-icon" />
              <FuelTypography size="body-sm" color="neutral-default" weight="medium">
                sem conta digital
              </FuelTypography>
            </FuelFlex>
          </FuelTooltip>
        )}
      </Styled.Account>
    </FuelFlex>
  );
};

export default Body;
